import { render, staticRenderFns } from "./WelcomeView.vue?vue&type=template&id=45dc7706&scoped=true"
import script from "./WelcomeView.vue?vue&type=script&lang=js"
export * from "./WelcomeView.vue?vue&type=script&lang=js"
import style0 from "./WelcomeView.vue?vue&type=style&index=0&id=45dc7706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dc7706",
  null
  
)

export default component.exports